import type { User } from '@/hooks/v1/types/User'
import { userRole } from '@/hooks/v1/types/UserRole'

export function isUserAdmin(user?: User) {
  return user?.roles?.includes(userRole.ADMIN)
}

export function isUserIntegrator(user?: User) {
  return user?.roles?.includes(userRole.INTEGRATOR)
}

export function isUserAdminOrIntegrator(user?: User) {
  return isUserAdmin(user) || isUserIntegrator(user)
}

export function isUserCompetitionManager(user?: User) {
  return user?.roles?.includes(userRole.COMPETITION_MANAGER)
}

export function isUserAffiliateManager(user?: User) {
  return user?.roles?.includes(userRole.AFFILIATE_MANAGER)
}

export function isUserAdminOrManager(user?: User, competitionId?: string) {
  return isUserAdmin(user) || isUserAdminOrCompetitionManager(user, competitionId)
}

export function isUserAdminIntegratorOrCompetitionManager(
  user?: User,
  competitionId?: string | null,
  competitionTenantId?: string | null,
) {
  return (
    isUserAdmin(user) ||
    (isUserIntegrator(user) &&
      Boolean(competitionTenantId) &&
      user?.tenant_id === competitionTenantId) ||
    isUserAdminOrCompetitionManager(user, competitionId)
  )
}

export function isUserAdminOrCompetitionManager(user?: User, competitionId?: string | null) {
  if (!competitionId) return false
  return isUserCompetitionManager(user) && user?.managed_competition_ids?.includes(competitionId)
}
